var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.217,
    height: 88.261,
    viewBox: "0 0 75.217 88.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_663",
    x: 36.391,
    y: 57.218,
    width: 20.434,
    height: 31.043,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_664",
    x: 10.217,
    y: 57.218,
    width: 20.434,
    height: 31.043,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_665",
    x: 24.521,
    y: 0,
    width: 33.326,
    height: 52.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_666",
    x: 4.086,
    y: 40.87,
    width: 20.043,
    height: 31.043,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_675",
    x: 6.218,
    y: 7.153,
    width: 36.214,
    height: 39.217,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_670",
    x: 50.696,
    y: 57.218,
    width: 20.434,
    height: 31.043,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_671",
    x: 41.891,
    y: 0,
    width: 33.326,
    height: 84.174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_672",
    x: 42.912,
    y: 40.87,
    width: 20.044,
    height: 31.043,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_682",
    x: 14.057,
    y: 2.823,
    width: 20,
    height: 31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_683",
    x: 14.057,
    y: 19.823,
    width: 20,
    height: 32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_673",
    x: 6.13,
    y: 25.544,
    width: 54.783,
    height: 48.881,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_674",
    x: 0,
    y: 36.783,
    width: 67.044,
    height: 47.392,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#952114"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_588",
    "data-name": "Groupe 588",
    transform: "translate(-573.001 -575.951)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_663-2",
    "data-name": "Trac\\xE9 663",
    d: "M798.141,914.043V912h-2.434l1.022,2.043Zm0,0",
    transform: "translate(-750.32 -854.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_664-2",
    "data-name": "Trac\\xE9 664",
    d: "M642,912v2.043h1.412L644.434,912Zm0,0",
    transform: "translate(-622.78 -854.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_665-2",
    "data-name": "Trac\\xE9 665",
    d: "M727.022,595.413H726V599.5h15.326V576H728.043A2.046,2.046,0,0,0,726,578.043v3.065a1.022,1.022,0,0,1,1.018.937l1.022,12.261a1.023,1.023,0,0,1-1.018,1.107Zm0,0",
    transform: "translate(-692.48 -576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_666-2",
    "data-name": "Trac\\xE9 666",
    d: "M608.043,817.022A1.022,1.022,0,1,1,607.022,816a1.022,1.022,0,0,1,1.022,1.022Zm0,0",
    transform: "translate(-592.91 -775.13)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_675-2",
    "data-name": "Trac\\xE9 675",
    d: "M618.52,628.217h18.214L635.883,618H619.371Zm0,0",
    transform: "translate(-603.3 -610.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_670)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_670-2",
    "data-name": "Trac\\xE9 670",
    d: "M882.141,912h-2.434l1.022,2.043h1.412Zm0,0",
    transform: "translate(-820.01 -854.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_671-2",
    "data-name": "Trac\\xE9 671",
    d: "M828,576v23.629a4.1,4.1,0,0,1,3.065,3.958v7.225a7.153,7.153,0,0,1,0,14.159v4.16a4.055,4.055,0,0,1-.55,2.043h10.768a2.046,2.046,0,0,0,2.043-2.043V578.043A2.046,2.046,0,0,0,841.283,576Zm0,0",
    transform: "translate(-777.11 -576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_672-2",
    "data-name": "Trac\\xE9 672",
    d: "M836.044,817.022A1.022,1.022,0,1,1,835.022,816a1.022,1.022,0,0,1,1.022,1.022Zm0,0",
    transform: "translate(-782.09 -775.13)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Rectangle_682)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682-2",
    "data-name": "Rectangle 682",
    width: 2,
    height: 2,
    transform: "translate(23.06 2.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Rectangle_683)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683-2",
    "data-name": "Rectangle 683",
    width: 2,
    height: 3,
    transform: "translate(23.06 19.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_673-2",
    "data-name": "Trac\\xE9 673",
    d: "M636.391,744.391a46.742,46.742,0,0,1,12.261,1.49v-3.432a7.258,7.258,0,0,1,6.13-7.177v-7.229A2.046,2.046,0,0,0,652.739,726h-32.7A2.046,2.046,0,0,0,618,728.043v7.226a7.151,7.151,0,0,1,6.13,7.078v3.534a46.743,46.743,0,0,1,12.261-1.49Zm9.2-9.2h2.043v2.044h-2.043Zm-5.109-5.109h2.044v2.044h-2.044Zm0,10.217h2.044v2.044h-2.044ZM635.37,735.2h2.044v2.044H635.37Zm-5.109-5.109H632.3v2.044h-2.043Zm0,10.217H632.3v2.044h-2.043Zm-5.109-5.109H627.2v2.044h-2.043Zm0,0",
    transform: "translate(-602.87 -700.46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 573, 575.95)",
    filter: "url(#Trac\\xE9_674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_674-2",
    "data-name": "Trac\\xE9 674",
    d: "M587.112,802.217a1.022,1.022,0,0,1,1.022,1.022v5.109a2.046,2.046,0,0,0,2.043,2.044h32.7a2.046,2.046,0,0,0,2.043-2.044v-5.109a1.022,1.022,0,0,1,1.022-1.022A5.109,5.109,0,1,0,625.85,792a5.184,5.184,0,0,0-5.021,5.209v4.062a17.032,17.032,0,0,1,2.544,1.076l-1,1.781c-.051-.029-5.4-2.934-15.847-2.934s-15.8,2.906-15.849,2.936l-1-1.783a16.948,16.948,0,0,1,2.544-1.076v-4.163a5.109,5.109,0,1,0-5.109,5.109Zm35.761-5.109a3.065,3.065,0,1,1,3.065,3.065,3.065,3.065,0,0,1-3.065-3.065Zm-35.761-3.065a3.065,3.065,0,1,1-3.065,3.065,3.065,3.065,0,0,1,3.065-3.065Zm0,0",
    transform: "translate(-573 -755.22)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.00a3ff0db099db614a5cefbeff0dd18e.svg";
export { ForwardRef as ReactComponent };